import * as React from 'react';

import { UitkText } from 'uitk-react-text';

export interface SpaceLayoutDescriptionProps {
  name: string;
}

export const SpaceLayoutDescription: React.FunctionComponent<SpaceLayoutDescriptionProps> = ({ name }) => (
  <UitkText size={300} className="all-t-margin-two pwa-theme--grey-700">
    {name}
  </UitkText>
);
SpaceLayoutDescription.displayName = 'SpaceLayoutDescription';
